import OrganizationCard from "./OrganizationCard";

function Evacuation() {
  const evacuation = [
    {
      name: "Demandes d'évacuation",
      objective:
        "Pour faire une demande d'évacuation depuis Mayotte mais aussi vers Mayotte, envoyez un e-mail à cette adresse : rapatriement-aerien@mayotte.gouv.fr. Expliquez votre situation et donnez les informations de votre carte d'identité ou de votre passeport. Vous recevrez un e-mail avec un document à remplir et à renvoyer. Après étude de votre dossier, vous serez recontacté.",
      verificationDate: "21/12/2024",
      link: "mailto:rapatriement-aerien@reunion.gouv.fr",
      buttonText: "Envoyer un e-mail",
    },
  ];

  return (
    <div className="content-container">
      <div className="evacuation-grid card-grid">
        {evacuation.map((site, index) => (
          <OrganizationCard
            key={index}
            organization={site.name}
            objective={site.objective}
            verificationDate={site.verificationDate}
            imageUrl={site.imageUrl}
            link={site.link}
            phone={site.phone}
            buttonText={site.buttonText}
          />
        ))}
      </div>
    </div>
  );
}

export default Evacuation;
